export class FloatingTextarea {
    /**
     * @type {HTMLElement}
     * @private
     */
    _domElm;

    /**
     * @type {HTMLElement}
     * @private
     */
    _label;

    /**
     * @type {HTMLTextAreaElement}
     * @private
     */
    _textarea;

    get domElm() {
        return this._domElm;
    }

    set domElm(value) {
        this._domElm = value;
    }

    get label() {
        return this._label;
    }

    set label(value) {
        this._label = value;
    }

    get textarea() {
        return this._textarea;
    }

    set textarea(value) {
        this._textarea = value;
    }

    constructor(domElm) {
        this.domElm = domElm;
        this.label = this.domElm;
        this.textarea = this.domElm.querySelector('textarea');

        if (!this.textarea) return;

        this.init();
    }

    init() {
        // Extraire le texte du label et le mettre dans data-label
        const labelText = this.getLabelText();
        if (labelText) {
            this.label.setAttribute('data-label', labelText);
            // Vider le contenu texte du label (garder seulement le span avec le textarea)
            this.cleanLabelContent();
        }

        // Ajouter la classe active si le champ a déjà une valeur
        this.checkValue();

        // Événements
        this.textarea.addEventListener('focus', () => this.activate());
        this.textarea.addEventListener('blur', () => this.checkValue());
        this.textarea.addEventListener('input', () => this.checkValue());

        // Click sur le label pour focus le textarea
        this.label.addEventListener('click', (e) => {
            if (e.target === this.label) {
                this.textarea.focus();
            }
        });
    }

    getLabelText() {
        // Récupérer le texte du label (avant le span)
        const clone = this.label.cloneNode(true);
        const span = clone.querySelector('.wpcf7-form-control-wrap');
        if (span) span.remove();
        return clone.textContent.trim();
    }

    cleanLabelContent() {
        // Garder seulement le span avec le textarea
        const span = this.label.querySelector('.wpcf7-form-control-wrap');
        if (span) {
            this.label.innerHTML = '';
            this.label.appendChild(span);
        }
    }

    activate() {
        this.label.classList.add('is-active');
    }

    deactivate() {
        this.label.classList.remove('is-active');
    }

    checkValue() {
        const hasValue = this.textarea.value && this.textarea.value.trim() !== '';
        const isFocused = this.textarea === document.activeTav;

        if (hasValue || isFocused) {
            this.activate();
        } else {
            this.deactivate();
        }
    }
}
